import { ValidationConfigProps } from '../types';

export const normalizeConfig = (config: ValidationConfigProps) => {
  if (Array.isArray(config)) {
    return config;
  }

  return [config];
};
